// Kept separate from ./hook so field components can import useFieldContext
// without creating a hook ↔ field-components circular import.
import { createFormHookContexts } from '@tanstack/react-form';

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();
